import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import TabsHeader from 'components/TabsHeader/TabsHeader';
import { usePerms } from 'contexts/PermsContext';
import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getWorkplaceMembers } from 'services/organization/organization.service';
import { getAllRoles } from 'services/roles/roles.service';
import { getVisibleUsers } from 'utils/roleUtils';
import MembersTab from './Components/MembersTab';
import RolesTab from './Components/RolesTab';

export default function RoleManager() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const perms = usePerms();
  const [roleList, setRoleList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    (async () => {
      await getAllRoles().then((res) => {
        setRoleList([...res.data.result]);
      });

      await getWorkplaceMembers(getVisibleUsers(perms)).then((res) => {
        setMemberList([...res.data.result]);
      });
    })();
  }, []);

  const renderTab = () => {
    switch (params.get('tab')?.toLowerCase()) {
      case 'roles':
        if (perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewRoles']))
          return (
            <RolesTab
              list={roleList}
              mousePosition={mousePosition}
              setMousePosition={setMousePosition}
              perms={perms}
              setRoleList={setRoleList}
            />
          );
        break;
      case 'users':
        if (perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewUsers']))
          return (
            <MembersTab
              list={memberList}
              setMemberList={setMemberList}
              mousePosition={mousePosition}
              perms={perms}
              setMousePosition={setMousePosition}
              roleList={roleList}
              onCreateUser={() => {
                navigate('/system/createuser?tab=create new user');
              }}
            />
          );
        break;
      default:
        return (
          <RolesTab
            list={roleList}
            mousePosition={mousePosition}
            setMousePosition={setMousePosition}
            perms={perms}
            setRoleList={setRoleList}
          />
        );
    }
  };

  return (
    <Container fluid className="py-3 vh-100 d-flex flex-column" style={{ boxSizing: 'border-box' }}>
      {/* header */}
      <div className="d-none d-lg-block">
        <TabsHeader
          options={[
            ...(perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewRoles'])
              ? [{ option: 'Roles' }]
              : []),
            ...(perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewUsers'])
              ? [{ option: 'Users' }]
              : []),
          ]}
        />
      </div>
      <div className="d-block d-lg-none">
        <MobileTabsHeader
          options={[
            ...(perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewRoles'])
              ? [{ option: 'Roles' }]
              : []),
            ...(perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewUsers'])
              ? [{ option: 'Users' }]
              : []),
          ]}
        />
      </div>
      {/* content */}
      <div className="d-flex flex-grow-1" style={{ minHeight: 0 }}>
        {renderTab()}
      </div>
    </Container>
  );
}
